import { useQuery } from "@apollo/client/react/hooks";

/**
 * This is how useQuery behaved in apollo-client v2.
 * https://github.com/apollographql/apollo-client/pull/6566
 */
export const useQueryWithPreviousData: typeof useQuery = (...args) => {
  const result = useQuery(...args);
  if ("previousData" in result && result.loading && !result.data) {
    return {
      ...result,
      data: result.previousData,
    };
  }
  return result;
};
